import { authRoutes } from '@/router/routes/auth-routes.js';
import { guestRoutes } from '@/router/routes/guest-routes.js';

const routes = [...authRoutes, ...guestRoutes];

export default routes;
